import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const { params, pageAssetsData, currentPageAssets, inProgress, error } = props;
  const pageId = params.pageId || props.pageId;

  // A7-01: the browser fetches the app assets before hydration, which clears the server's 404
  // error. A page whose own fetch already ran (its id is in currentPageAssets) and gave no data
  // is still the missing page, so the first client render matches the server's NotFoundPage
  // instead of mounting a second page next to it.
  const pageFetchedWithoutData =
    !pageAssetsData?.[pageId] && !!currentPageAssets?.includes(pageId) && !error;

  if (!inProgress && (error?.status === 404 || pageFetchedWithoutData)) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, currentPageAssets, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, currentPageAssets, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(mapStateToProps)
)(CMSPageComponent);

export default CMSPage;
